import StorageService from './storage.service.js'

export default new StorageService(sessionStorage)
